import {
    CommandBarButton,
    Dropdown,
    IDropdownOption,
    MessageBar,
    MessageBarType,
    TextField
} from "office-ui-fabric-react";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import SchoolLicense from "../models/SchoolLicense";
import Actions from "../redux/Actions";
import { IRootState } from "../store";
import DispatchProps from "../utils/DispatchProps";
import ApiService from "./ApiService";
import {License, LICENSE_DROPDOWN_OPTIONS} from "../models/School";
import {AvailableLicense} from "../models/AvailableLicense";
import {UserAccessLevel, userAccessLevelIsAtLeast} from "../models/UserAccessRecord";

interface AssignSchoolLicenseProps {
    tenantId: string;
    schoolCode: string;

    apiService: ApiService;
    usersCdbAccessLevel?: UserAccessLevel;
}

interface AssignSchoolLicenseState {
    availableLicenses?: AvailableLicense[];
    existingLicense?: SchoolLicense;
    
    selectedCustomerReferenceToAssign?: string;
    
    selectedLicenseForTemporary?: License;
}

class AssignSchoolLicense extends Component<AssignSchoolLicenseProps & DispatchProps, AssignSchoolLicenseState> {

    constructor(props: AssignSchoolLicenseProps & DispatchProps) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId && this.props.schoolCode)
        {
            await this.load();
        }
    }

    async componentDidUpdate(prevProps: Readonly<AssignSchoolLicenseProps & DispatchProps>, prevState: Readonly<AssignSchoolLicenseState>, snapshot?: any): Promise<void> {
        if (prevProps.tenantId != this.props.tenantId || prevProps.schoolCode != this.props.schoolCode)
        {
            await this.load();
        }
    }

    private async load(): Promise<void>
    {
        try
        {
            const existingLicense = await this.props.apiService.getLicenseAdmin(this.props.tenantId, this.props.schoolCode);
            const availableLicenses = await this.props.apiService.getAvailableLicenses();
            
            this.setState({
                existingLicense: existingLicense,
                availableLicenses: availableLicenses
            });
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar("Unable to load license details", MessageBarType.error));
        }
    }
    
    
    buildAssignedView(): JSX.Element
    {
        let date = new Date(this.state.existingLicense!.licenseEndDate);
        let endMonth = "";
        let endYear = "";
        if (!isNaN(date.getTime())) {
            endMonth = (date.getMonth() + 1).toString();
            endYear = date.getFullYear().toString();
        }
        
        return (
            <Fragment>
                <TextField className="card__input"
                           label={"License Reference"}
                           disabled={true}
                           description={"Internal CDB code which identifies the school's license, should usually match the value in other systems such as Freshdesk and Pipedrive."}
                           value={this.state.existingLicense!.licenseReference}/>

                <Dropdown
                    selectedKey={this.state.existingLicense!.license}
                    label={"License"}
                    placeholder={"Unknown"}
                    disabled={true}
                    options={LICENSE_DROPDOWN_OPTIONS}
                />

                <TextField className="card__input"
                           label="End Year"
                           disabled={true}
                           value={endYear}/>

                <TextField className="card__input"
                           label="End Month"
                           disabled={true}
                           value={endMonth}/>
            </Fragment>
        );
    }
    
    buildUnassignedView(): JSX.Element | null {
        
        if(!this.state.availableLicenses)
        {
            return null;
        }
        
        
        const dropdownOptions: IDropdownOption[] = this.state.availableLicenses.map(al => {
            return {
                text: `${al.customerReferenceNumber} - ${al.title} - ${al.endDate}`,
                key: al.customerReferenceNumber,
                data: al
            } as IDropdownOption;
        })
        
        return (
            <div>
                <Dropdown
                    label={"Available Licenses"}
                    
                    options={dropdownOptions}
                    selectedKey={this.state.selectedCustomerReferenceToAssign}
                    onChange={(e: any,option: IDropdownOption | undefined) => {
                        this.setState({
                            selectedCustomerReferenceToAssign: option!.key as string
                        });
                    }}
                />

                {this.buildTemporaryLicenseArea()}
            </div>);
    }
    
    buildTemporaryLicenseArea(): JSX.Element {

        const isAdmin = userAccessLevelIsAtLeast("admin", this.props.usersCdbAccessLevel);
        
        const licenseDropdown = (
            <Dropdown
                selectedKey={this.state.selectedLicenseForTemporary}
                disabled={!isAdmin}
                label={"License"}
                placeholder={"Unknown"}
                options={LICENSE_DROPDOWN_OPTIONS}
                onChange={(e: any, option: any) => {
                    if (option) {
                        this.setState({
                            selectedLicenseForTemporary: option.key
                        });
                    }
                }}
            />
        );
        return (
            <div className="card">
                <div className="card__header">
                    <span className={"card__title"}>Temporary License (Admin only)</span>
                    <CommandBarButton
                        disabled={!isAdmin}
                        iconProps={{ iconName: "Save" }}
                        text="Assign Temporary License"
                        onClick={this.assignTemporary}
                    />
                </div>
                <MessageBar messageBarType={MessageBarType.warning}>
                    Assign a temporary licence for use in exceptional circumstances such as migrations
                </MessageBar>
                <div className="card__content">
                  
                    {licenseDropdown}
                </div>
            </div>
        );


    }


    assign = async () => {

        if (!this.state.selectedCustomerReferenceToAssign) {
            return;
        }

        try {
            await this.props.apiService.assignAvailableLicense(this.props.tenantId, this.props.schoolCode, this.state.selectedCustomerReferenceToAssign);
            this.props.dispatch(Actions.showMessageBar("Successfully assigned license", MessageBarType.success));

            await this.load();
        } catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Failed to assign license : ${e.message}`, MessageBarType.error));
        }

    }

    unassign = async () => {
        if (!this.state.existingLicense?.licenseReference)
        {
            return;
        }

        try
        {
            await this.props.apiService.unassignLicense(this.props.tenantId, this.props.schoolCode);
            this.props.dispatch(Actions.showMessageBar("Successfully unassigned license", MessageBarType.success));

            await this.load();
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Failed to unassign license : ${e.message}`, MessageBarType.error));
        }
    }
    
    assignTemporary = async () => {
        
        if(!this.state.selectedLicenseForTemporary)
        {
            return;
        }

        try
        {
            await this.props.apiService.assignTemporaryLicense(this.props.tenantId, this.props.schoolCode,this.state.selectedLicenseForTemporary);
            this.props.dispatch(Actions.showMessageBar("Successfully assigned temporary license", MessageBarType.success));

            await this.load();
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Failed to assign temporary license : ${e.message}`, MessageBarType.error));
        }
    }

    render(): JSX.Element | null {
        
        if(this.state.existingLicense === undefined)
        {
            return null;
        }
        
        let actions: JSX.Element | null = null;
        let content: JSX.Element | null = null;
        
        if(this.state.existingLicense.licenseReference)
        {
            actions = (
                <CommandBarButton
                    disabled={false}
                    iconProps={{ iconName: "Clear" }}
                    text="Unassign License"
                    onClick={this.unassign}
                />
            );
            content = this.buildAssignedView();
        }
        else
        {
            actions = (
                <CommandBarButton 
                    disabled={!this.state.selectedCustomerReferenceToAssign}
                    iconProps={{ iconName: "Save" }}
                    text="Assign license"
                    onClick={this.assign}
                />);
            content = this.buildUnassignedView();
        }
        
        return (
            <Fragment>
                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Assign License</span>

                        {actions}
                  
                    </div>
                    <div className="card__content flex-column">
                        {content}
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { schoolCode: string, tenantId: string }): AssignSchoolLicenseProps => {
        return {
            schoolCode: ownProps.schoolCode,
            tenantId: ownProps.tenantId,
            apiService: state.auth.apiService,
            usersCdbAccessLevel: state.auth.usersCdbAccessLevel
        };
    }
)(AssignSchoolLicense)